// extracted by css-extract-rspack-plugin
export default {"avatarFrame":"ulK3x","text":"OKQFg"};